class PreferencesSettings {
  constructor() {
    this.CurrentPassword = '';
    this.NewPassword = '';
    this.ConfirmPassword = '';
    this.ChangeEmail = '';
    this.AlternateEmail = '';
    this.AllowEmployeeViewInfo = '';
    this.AllowResponsiblyPartyViewInfo = '';
    this.RespParty = [];
    this.RespPartyName = [];
    this.RespPartyRelationship = [];
  }

  getCurrentPassword() {
    return this.CurrentPassword;
  }

  setCurrentPassword(currentPassword) {
    this.CurrentPassword = currentPassword;
  }

  getNewPassword() {
    return this.NewPassword;
  }

  setNewPassword(newPassword) {
    this.NewPassword = newPassword;
  }

  getConfirmPassword() {
    return this.ConfirmPassword;
  }

  setConfirmPassword(confirmPassword) {
    this.ConfirmPassword = confirmPassword;
  }

  getChangeEmail() {
    return this.ChangeEmail;
  }

  setChangeEmail(changeEmail) {
    this.ChangeEmail = changeEmail;
  }

  getAlternateEmail() {
    return this.AlternateEmail;
  }

  setAlternateEmail(alternateEmail) {
    this.AlternateEmail = alternateEmail;
  }

  getAllowEmployeeViewInfo() {
    return this.AllowEmployeeViewInfo;
  }

  setAllowEmployeeViewInfo(allowEmployeeViewInfo) {
    this.AllowEmployeeViewInfo = allowEmployeeViewInfo;
  }

  getAllowResponsiblyPartyViewInfo() {
    return this.AllowResponsiblyPartyViewInfo;
  }

  setAllowResponsiblyPartyViewInfo(allowResponsiblyPartyViewInfo) {
    this.AllowResponsiblyPartyViewInfo = allowResponsiblyPartyViewInfo;
  }

  getRespParty() {
    return this.RespParty;
  }

  setRespParty(respParty) {
    this.RespParty = respParty;
  }

  getRespPartyName() {
    return this.RespPartyName;
  }

  setRespPartyName(respPartyName) {
    this.RespPartyName = respPartyName;
  }

  getRespPartyRelationship() {
    return this.RespPartyRelationship;
  }

  setRespPartyRelationship(respPartyRelationship) {
    this.RespPartyRelationship = respPartyRelationship;
  }

  resetPreferencesSettings() {
    this.CurrentPassword = '';
    this.NewPassword = '';
    this.ConfirmPassword = '';
    this.ChangeEmail = '';
    this.AlternateEmail = '';
    this.AllowEmployeeViewInfo = '';
    this.AllowResponsiblyPartyViewInfo = '';
    this.RespParty = [];
    this.RespPartyName = [];
    this.RespPartyRelationship = [];
  }
}

export default new PreferencesSettings();
